/* jshint esversion: 6, -W097 */
/* globals require */
'use strict';

/**
 * Creates an image gallery
 *
 * Usage example:
 * <image-gallery data-images="ProductCtrl.productImages"></image-gallery>
 *
 * ProductCtrl.productImages object example:
 * [
 *    '/assets/img/products/ph.jpg',
 *    '/assets/img/products/ph2.jpg',
 *    '/assets/img/products/ph3.jpg',
 *    '/assets/img/products/ph4.jpg',
 *    '/assets/img/products/ph5.jpg',
 *    '/assets/img/products/ph6.jpg'
 * ]
 *
 */
function imageGalleryDirective() {
    return {
        restrict: 'E',
        scope: {
            images: '=',
            productBrand: '=',
            productModel: '=',
            productImageSizes: '='
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: imageGalleryController,
        template: require('./imageGalleryView.html')
    };
}

function imageGalleryController () {

    this.$onInit = function () {
        var vm = this;
        // If the product does not have any images, hide the image gallery section
        if (!vm.images || vm.images.length === 0) {
            vm.noImagesAvailable = true;
            return;
        }

        vm.noImagesAvailable = false;

        vm.selectedImage = vm.images[0];

        /**
         * Selects a particular image to be shown in the preview section
         *
         * @param selectedImageUrl
         */
        vm.selectImage = function (selectedImageUrl) {
            vm.selectedImage = selectedImageUrl;
        };
    }
}

module.exports = imageGalleryDirective;
